export default __webpack_public_path__ + "static/media/arrow-clockwise.2ba77545.svg";